import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flexWrap" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flexWrap" }, null, -1)
const _hoisted_3 = {
  slot: "footer",
  class: "flexCenter"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("提 交")

import { requestEditUserGroupInfo,requestUserGroupInfo } from '@/api/api'
	import { xmUser } from '@/api/xmApi'
	import { ref,onMounted } from 'vue'
	import { ElMessage } from 'element-plus'
	interface formType {
		gruopname: string
		rolelist: string
	}
	
export default /*#__PURE__*/_defineComponent({
  name: 'AddUserGroup',
  props: {
		uuid:{
			type: String,
			default: ""
		}
	},
  emits: ['cancel'],
  setup(__props, { emit }) {

const props = __props

    const xmUserList = ref<number[]>([])
	const userLists = ref<any[]>([])
	
	
	const form = ref<formType>({
		uuid:'',
		user:'',
		pwd:'',
		name:'',
		rolelist:'',
	})
	onMounted(()=>{
		if(props.uuid != ""){
			requestUserGroupInfo({
				id:props.uuid
			}).then((res:any)=>{
				if(res.status === 1){
					form.value = res.datalist;
					getUserList();
				}
			})
		}else{
			getUserList();
		}
		
	})
	const getUserList = () =>{
		xmUser().then((res:any)=>{
			if(res.status === 1){
				userLists.value = res.datalist
				if(props.uuid != ""){
					requestUserGroupInfo({
						id:props.uuid
					}).then((ress:any)=>{
						if(ress.status === 1){
							form.value = ress.datalist
							xmUserList.value = ress.datalist.useridlist.split(",")
						}
					})
				}
			}
		})
	}
	const qx = () =>{
		emit("cancel")
	}
    const submit = () =>{
    	console.log(form.value.gruopname );
    	console.log(xmUserList.value);
    	console.log(xmUserList.value.join());
		if(form.value.gruopname === "" ){
			ElMessage.error("用户组名称不能为空");
			return
		}
        requestEditUserGroupInfo({
            id:props.uuid,
            gruopname:form.value.gruopname,
            useridlist:xmUserList.value.join()
        }).then((res:any)=>{
            if(res.status === 1){
                ElMessage({
                    message: res.msg,
                    type: 'success',
                    duration: 500
                });
				setTimeout(()=>{
					emit("cancel",1)
				},500)
            }
        })
    }

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      "label-width": "80px",
      style: {"background-color":"#fff","padding":"30px 20px"},
      "show-message": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_form_item, { label: "用户组" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.value.gruopname,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.gruopname) = $event)),
                placeholder: "请输入用户组",
                style: {"width":"200px"}
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "成员" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                filterable: "",
                modelValue: xmUserList.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((xmUserList).value = $event)),
                multiple: "",
                placeholder: "请选择",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userLists.value, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: item.name,
                      value: item.id,
                      key: index
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_button, {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (qx())),
        round: ""
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        style: {"color":"#fff"},
        type: "primary",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (submit())),
        round: ""
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})